import LoadingGif from "../../images/loading-animation-whitefd.gif"

export default function Loading(){

    return <img alt={"loading"} src={LoadingGif}/>

}